import { render, staticRenderFns } from "./FormInputs.vue?vue&type=template&id=5ba546e3"
import script from "./FormInputs.vue?vue&type=script&lang=js"
export * from "./FormInputs.vue?vue&type=script&lang=js"
import style0 from "./FormInputs.vue?vue&type=style&index=0&id=5ba546e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports